<av-card
  [backdrop]="false"
  [type]="isStandalone() ? 'ghost' : 'container'"
  class="cobrowse"
  [class.cobrowse-tile]="!isStandalone()"
>
  <!-- controls -->
  <div
    class="cobrowse-header-actions fx-row fx-align-center fx-justify-space-between"
    [class.cobrowse-header-actions-standalone]="isStandalone()"
  >
    <div class="cobrowse-header-actions-left">
      @if (!!activeSketchId) {
      <app-sketch-controls
        (controlStateChanged)="sketchControlStateChanged($event)"
        [room]="activeSketchId"
        [disabled]="isSketchControlsDisabled()"
      >
      </app-sketch-controls>
      }
    </div>

    <div class="cobrowse-header-actions-right fx-row fx-align-center">
      @if (isResizeAvailable()) {
      <av-tooltip position="bottom">
        <button
          avButton
          ofType="icon"
          size="xs"
          [raised]="true"
          [disabled]="isResizeDisabled()"
          (click)="expand()"
          data-tid="cobrowse-session/toggle-expand"
        >
          @if (!isFullWidth()) {
          <av-icon size="sm" name="expand"></av-icon>
          } @if (isFullWidth()) {
          <av-icon size="sm" name="collapse"></av-icon>
          }
        </button>
        <ng-container tooltipMessage>
          @if (!isFullWidth()) {
          {{ "Actual size" | translate }}
          } @if (isFullWidth()) {
          {{ "Fit to view" | translate }}
          }
        </ng-container>
      </av-tooltip>
      } @if (isRemoteDisplayCaptureAvailable()) {
      <av-tooltip position="bottom">
        <button
          avButton
          ofType="icon"
          size="xs"
          [color]="isCapturingRemoteDisplay() ? 'danger' : 'basic'"
          [loading]="isRequestingDisplayCapture()"
          [disabled]="isCaptureRemoteDisplayDisabled()"
          [raised]="true"
          (click)="toggleDisplayCapture()"
          data-tid="cobrowse-session/request-screen-share"
        >
          @if (!isCapturingRemoteDisplay()) {
          <av-icon size="sm" name="screen-in"></av-icon>
          } @if (isCapturingRemoteDisplay()) {
          <av-icon size="sm" name="screen-stop"></av-icon>
          }
        </button>
        <ng-container tooltipMessage>
          @if (!isCapturingRemoteDisplay()) {
          {{ "Request desktop capture" | translate }}
          } @if (isCapturingRemoteDisplay()) {
          {{ "Stop desktop capture" | translate }}
          }
        </ng-container>
      </av-tooltip>
      } @if (isLocalDisplayCaptureAvailable()) {
      <av-tooltip position="bottom">
        <button
          avButton
          ofType="icon"
          size="xs"
          [raised]="true"
          [color]="isLocalDisplayCaptureActive() ? 'danger' : 'basic'"
          [loading]="isLocalDisplayCaptureLoading()"
          [disabled]="isLocalDisplayCaptureDisabled()"
          (click)="toggleLocalDisplayCapture()"
          data-tid="cobrowse-session/screen-share/start"
        >
          @if (!isLocalDisplayCaptureActive()) {
          <av-icon size="sm" name="screen-out"></av-icon>
          } @if (isLocalDisplayCaptureActive()) {
          <av-icon size="sm" name="screen-stop"></av-icon>
          }
        </button>
        <ng-container tooltipMessage>
          @if (!isCapturingLocalDisplay()) {
          {{ "Share your screen" | translate }}
          } @if (isCapturingLocalDisplay()) {
          {{ "Stop sharing screen or window" | translate }}
          }
        </ng-container>
      </av-tooltip>
      } @if (isRequestControlAvailable()) {
      <av-tooltip position="bottom">
        <button
          avButton
          ofType="icon"
          size="xs"
          [raised]="true"
          [color]="isControlGranted() ? 'accent' : 'basic'"
          [disabled]="isRequestControlDisabled()"
          [loading]="isRequestingControl()"
          (click)="requestControl()"
          data-tid="cobrowse-session/request-control"
        >
          <av-icon size="sm" name="text"></av-icon>
        </button>
        <ng-container tooltipMessage>
          @if (!isControlGranted()) { @if (!isRequestingControl()) {
          {{ "Request control" | translate }}
          } @if (isRequestingControl()) {
          {{ "Waiting for approval" | translate }}
          } } @if (isControlGranted()) {
          {{ "Editing Page" | translate }}
          }
        </ng-container>
      </av-tooltip>
      }

      <!--end -->
      <av-confirm
        [open]="isConfirmOpen()"
        arrow="top-right"
        (confirmed)="end()"
        (canceled)="isConfirmOpen.set(false)"
      >
        <av-tooltip
          [enabled]="!isConfirmOpen()"
          position="bottom"
          message="End session"
        >
          <button
            class="exit"
            avButton
            ofType="icon"
            size="xs"
            color="basic"
            [raised]="true"
            (click)="isConfirmOpen.set(true)"
            data-tid="cobrowse-session/end"
          >
            <av-icon name="close-big"></av-icon>
          </button>
        </av-tooltip>
        <span confirmTitle translate>End session</span>
        <span confirmBody translate>Are you sure you want to quit?</span>
      </av-confirm>
    </div>
  </div>

  <app-cobrowse-frame
    #cobrowseView
    class="cobrowse-frame"
    [class.cobrowse-frame-back]="
      isCapturingRemoteDisplay() || isCapturingLocalDisplay()
    "
    [viewSize]="remoteFrameSize()"
    [sketchActive]="sketchActive"
    [cobrowseActive]="isCobrowseActive()"
    [allowLocalNetwork]="isLocalNetworkAccessEnabled()"
    (mouseRatioChanged)="mouseRatioChanged($event)"
    (containerRatioChanged)="containerRatioChanged($event)"
    (frameScrollChanged)="scrollChanged($event)"
    (containerScrollChanged)="scrollChanged($event)"
    (viewSizeChanged)="viewSizeChanged($event)"
  >
    @if (!isFrameReady() && !isCapturingRemoteDisplay() && !isCapturingLocalDisplay()) {
    <div
      class="cobrowse-info fx-column fx-align-center fx-justify-center"
      [class.cobrowse-info-standalone]="isStandalone()"
    >
      @if (isCobrowseRequest) {
      <av-icon [mode]="iconMode()" name="cobrowse"></av-icon>
      <h1 translate>Co-browse started</h1>
      } @if (isDisplayCaptureRequest) {
      <av-icon [mode]="iconMode()" name="cobrowse-screen"></av-icon>
      <h1 translate>Session started</h1>
      } @if (isWaitingToAccept()) {
      <h2 class="blink" translate>Waiting for customer...</h2>
      } @if (isCobrowseFrameOpen() && !isFrameReady()) {
      <h2 class="blink" translate>Retrieving page...</h2>
      }
    </div>
    }

    <app-sketch-area
      #sketch
      [scaleRatio]="mouseRatio"
      [viewSize]="remoteFrameSize()"
      [endpoint]="customerEndpoint"
      [class.sketch-active]="sketchActive"
      (connected)="sketchConnected($event)"
    >
    </app-sketch-area>

    <ng-container cobrowse-pointers>
      @if (isViewGranted()) {
      <app-pointer #pointer [sender]="customerName"></app-pointer>
      }
    </ng-container>
  </app-cobrowse-frame>

  <!-- <app-tile
  class="tile-ready"
  [stream]="screenStream"
  [interaction]="interaction"
  [@tileSlideIn]="true"
  *ngIf="!!screenStream"
  >
</app-tile> -->
  @if (isCapturingRemoteDisplay() || isCapturingLocalDisplay()) {
  <div
    class="tile"
    [class.tile-loading]="isPublishingLocalDisplay()"
    #tile
    [@tileSlideIn]="true"
  >
    @if (!!screenStream()) {
    <app-stream-view
      [id]="screenStream().id"
      [muted]="true"
      [stream]="screenMediaStream()"
      [type]="screenStream().type"
      (mediaElementReady)="mediaElementReady($event)"
    ></app-stream-view>
    } @if (isScreenAnnotationAvailable()) {
    <app-sketch-area
      class="screen-sketch"
      [displayCapture]="true"
      [sync]="true"
      [endpoint]="screenStream().originator"
      [stream]="screenSketchStream()"
      [viewSize]="screenViewSize()"
      [class.sketch-active]="sketchActive"
      (connected)="screenSketchConnected($event)"
      (ended)="screenSketchEnded()"
    >
    </app-sketch-area>
    } @if (!screenStream() || isPublishingLocalDisplay()) {
    <av-spinner mode="light"></av-spinner>
    }
  </div>
  }
</av-card>
